module.exports = __webpack_public_path__ + "fonts/font.880f921.woff";